module.exports = __webpack_public_path__ + "media/images/front/varieties/NAVEL-LATE-8d037d4850731533d47831854dccd9a4.jpg";